import type { CampaignKnowledgeBaseFile } from '@features/Admin/KnowledgeBase/model/types';
import { isKnowledgeBaseFileAvailable } from '@features/Admin/KnowledgeBase/model/file-mapper';

export const getAvailableAgentFiles = (
  files: CampaignKnowledgeBaseFile[],
  agentId: string,
): CampaignKnowledgeBaseFile[] => {
  if (!agentId) return [];

  return files.filter(
    (file) =>
      (file.agentScope === 'all' ||
        (file.agentScope === 'selected' && file.agentIds.includes(agentId))) &&
      isKnowledgeBaseFileAvailable(file),
  );
};
